import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { Products } from "../products/products";
import { ProductsList } from "../products-list/products-list";
import { ProductsDetail } from "../products-detail/products-detail";
import { PRODUCTS_DESCRIBE } from "../constants";

@Injectable({ providedIn: 'root' })
export class ProductsRoutesProvider extends IDynamicRoutesProvider {
    override componentMap: Record<string, Type<any>> = {
        'products': Products,
        'products-list': ProductsList,
        'product-detail': ProductsDetail,
    };    

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'products';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, PRODUCTS_DESCRIBE);
    }
}